export default {
  LocationSelectInput: {
    inputPlaceholder: 'What city is your home in?',
  },
  MortgageSurveyFlowSelect: {
    starDescription: "America's best mortgage app ",
    starDescription2: 'with over $2 Billion in requests.',
    proofQuote:
      'This is fantastic, because the whole idea of Bundle is somebody actually cared what the experience was like for you as a consumer.',
    proofQuoteBy: 'Clark Howard',
    proofQuoteByDesc: 'NY Times #1 best-selling author',
  },
  AddressSelect: {
    loading: 'Loading...',
    error: 'Error',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/sharedComponents.js